import {ofType} from 'redux-observable'
import {ajax} from 'rxjs/ajax';
import {EMPTY, of} from 'rxjs';
import i18next from 'i18next';
import {catchError, map, mergeMap, mapTo, switchMap} from 'rxjs/operators';
import {toast} from "react-toastify";

import {LOGOUT_REQUEST_SUCCESS} from '../actions/Auth'

import {
    ADDING_NEW_CONTACT_REQUEST_START,
    addingNewContactRequestSuccess,
    addingNewContactRequestFail,
    ADDING_NEW_CONTACT_REQUEST_SUCCESS,
    addingNewContactToggleModal,

    IMPORT_NEW_CONTACTS_REQUEST_START,
    chatsClearData,
} from '../actions/Chats';

import {loadImportNewContacts} from "../thunks/Chats";

export const addingNewContactRequestEpics = (action$, state$) =>
    action$.pipe(
        ofType(ADDING_NEW_CONTACT_REQUEST_START),
        mergeMap(
            action => {
                const name = action.name ? {"name": action.name} : {};
                return ajax.post(
                    process.env.REACT_APP_API_URL + 'bot/import_botuser/',
                    {
                        "shop_id": state$.value.Shops.activeShop.id,
                        "phone": action.phone,
                        ...name,
                    },
                    {
                        Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                        'Content-Type': 'application/json',
                    }).pipe(
                    map(response => {
                        if (response.response.status === 'success') {
                            toast.success(i18next.t('chats.modal_adding_new_contact.new_user_added', 'New user added'));
                            return addingNewContactRequestSuccess(response.response.details)
                        }
                    }),
                    catchError(error => {
                        if (error.status == 400) {
                            return of(addingNewContactRequestFail({
                                'common': error.response.errors
                            }));
                        }
                        return of(addingNewContactRequestFail({
                            'common': i18next.t('errors.common.request_sent', 'Error sending request')
                        }));
                    })
                )
            }
        )
    );

export const addingNewContactToggleModalEpics = (action$, state$) =>
    action$.pipe(
        ofType(ADDING_NEW_CONTACT_REQUEST_SUCCESS),
        mapTo(addingNewContactToggleModal(false))
    );

export const importNewContactsRequestEpics = (action$, state$) =>
    action$.pipe(
        ofType(IMPORT_NEW_CONTACTS_REQUEST_START),
        switchMap(
            (action) => of(loadImportNewContacts(action.file))
        )
    );

export const chatsClearDataEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOGOUT_REQUEST_SUCCESS),
        map(chatsClearData)
    );